import { ComponentType } from 'react';
import { LeadCapturePageA } from '../pages/LeadCapturePageA';
import { LeadCapturePageB } from '../pages/LeadCapturePageB';
import { LeadFormWizardOnComplete } from '../forms/LeadFormWizard';

/**
 * Mapping of Split.io treatment names to lead form components
 * This allows the app to dynamically select components based on A/B test treatment
 */
type LeadCaptureComponentProps = {
    searchParams?: URLSearchParams;
    onComplete?: LeadFormWizardOnComplete;
    baseURL?: string;
    requirePhone?: boolean;
    appType?: 'application' | 'dashboard';
    env?: string;
};

type LeadCaptureComponent = ComponentType<LeadCaptureComponentProps>;

type LeadFormTreatmentsMap = Record<string, LeadCaptureComponent>;

export const LEAD_FORM_TREATMENTS: LeadFormTreatmentsMap = {
    control: LeadCapturePageA,
    variant_a: LeadCapturePageA,
    variant_b: LeadCapturePageB,
};

type TreatmentKey = keyof typeof LEAD_FORM_TREATMENTS;

/**
 * Get the appropriate lead form component for a treatment
 * @param treatment - The treatment name from Split.io
 * @returns The corresponding lead form component
 */
export const getLeadFormComponent = (treatment: string): LeadCaptureComponent => {
    const key = treatment as TreatmentKey;
    return LEAD_FORM_TREATMENTS[key] ?? LEAD_FORM_TREATMENTS.control;
};
